import { render } from "./Add.vue?vue&type=template&id=d13d5c2a"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
script.render = render

export default script